import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { CompleteProfileRequest, CreateDepartmentPayload, CreateStaffLevelPayload } from '../models/organisations.models';

@Injectable({
  providedIn: 'root'
})
export class OrganisationsService {
  private baseAPI = environment.baseAPI;

  constructor(private http: HttpClient) { }

  completeProfile(payload: CompleteProfileRequest): Observable<any> {
    return this.http.put(`${this.baseAPI}/Organisations`, payload);
  }

  createDepartment(payload: CreateDepartmentPayload): Observable<any> {
    return this.http.post(`${this.baseAPI}/OrganizationDepartments`, payload);
  }

  getDepartments(organizationId: string): Observable<any> {
    return this.http.get(`${this.baseAPI}/OrganizationDepartments`, {
      params: { organizationId }
    });
  }

  deleteDepartment(id: string): Observable<any> {
    return this.http.delete(`${this.baseAPI}/OrganizationDepartments/${id}`);
  }

  createStaffLevel(payload: CreateStaffLevelPayload): Observable<any> {
    return this.http.post(`${this.baseAPI}/OrganizationStaffLevels`, payload);
  }

  getStaffLevels(organizationId: string): Observable<any> {
    return this.http.get(`${this.baseAPI}/OrganizationStaffLevels`, {
      params: { organizationId }
    });
  }

  toggleStaffLevelStatus(id: string): Observable<any> {
    return this.http.patch(`${this.baseAPI}/OrganizationStaffLevels/${id}/toggle-status`, {});
  }

  getMetrics(organisationId: string, startDate?: string, endDate?: string): Observable<any> {
    let params = new HttpParams();
    if (startDate) {
      params = params.set('startDate', startDate);
    }
    if (endDate) {
      params = params.set('endDate', endDate);
    }
    return this.http.get(`${this.baseAPI}/Organisations/metrics`, { params });
  }

  getOrganisations(pageNumber: number = 1, pageSize: number = 100): Observable<any> {
    return this.http.get(`${this.baseAPI}/Organisations`, {
      params: { PageNumber: pageNumber.toString(), PageSize: pageSize.toString() }
    });
  }

  getOrganisationProfile(): Observable<any> {
    return this.http.get(`${this.baseAPI}/Organisations/profile`);
  }
}

